<template>
  <v-chip @click="open" class="cloudrec-chip" :color="color" text-color="white" small>
    <v-avatar class="teal"><v-icon>file_download</v-icon></v-avatar>
    {{title}}
  </v-chip>
</template>

<script>
import ClipModel from '@/models/clip.js'
export default {
  props: ['uuid', 'event_uuid', 'index'],
  data () {
    var ch = this.$cloudserver.channel("events:clip:"+this.uuid);
    return {
      clip: this.convertClip(ch.data),
      ws_channel: ch
    }
  },
  watch: {
    "ws_channel.data": {
      handler(newVal, oldVal) {
        this.clip = this.convertClip(newVal);
        this.$emit("status_changed", this.index, this.clip.status||"new")
      },
      deep: true
    }
  },
  created() {
    this.ws_channel.join();
    this.$emit("status_changed", this.index, this.clip.status||"new")
  },
  computed: {
    title () {
      return ClipModel.get_title(this.clip, "");
    },
    color() {
      if(this.clip.status == "ready") return "success";
      if(this.clip.status == "error") return "error";
      return "deep-orange";
    }
  },
  methods: {
    convertClip(newVal) {
      var clip= undefined;
      if (Array.isArray(newVal)) {
        new_clip = _.find(newVal, function(v) {
          return v.uuid == this.uuid;
        })
        if (typeof(new_clip) == "undefined" || new_clip == null) new_clip = newVal[0];
        clip = _.cloneDeep(new_clip);
      } else {
        clip = _.cloneDeep(newVal);
      }
      return clip;
    },
    open() {
      ClipModel.open(this.clip, true).catch(() => {
        this.ws_channel.push("regenerate_clip", {uuid: this.clip.uuid});
        this.add_process({type: "cloudrec", event: "re-create-clip", description: "Re-create clip "+this.clip.meta.title, meta: {uuids: [this.clip.uuid], event_uuid: this.event_uuid}});
      })
    }
  }
}
</script>
<style>
.cloudrec-chip.v-chip .v-chip__content {
  height: 28px;
}
</style>
